export const ContactTypeIcons = {
    "0": "edit",
    "1": "phone",
    "2": "phone_iphone",
    "3": "print",
    "4": "email",
    "5": "gavel"
};

export const SideNavIcons = {
    "la la-ambulance": "local_hospital",
    "la la-bank": "account_balance",
    "la la-bar-chart": "bar_chart",
    "la la-dashboard": "assessment",
    "la la-file-text ": "description",
    "la la-file-text": "description",
    "la la-folder-open": "folder_open",
    "la la-group": "people",
    "la la-money ": "money",
    "la la-money": "money",
    "la la-pencil ": "create",
    "la la-pencil": "create",
    "la la-suitcase": "work",
    "la la-user": "person"
};



// WEBPACK FOOTER //
// ./src/inar2/config/Icons.tsx